/**
 * This file is automatically generated. DO NOT MODIFY
 *
 * Generated By: scripts/generateEnums.js
 * Timestamp: Tue Jan 06 2026 13:03:07 GMT-0600 (Central Standard Time)
 */

import Enum from './enum.js'

/**
 * @enum {number}
 * @see {@link https://github.com/RVezy/rvezy-back-end/blob/master/RVezy.Common/Models/BookingStageEnum.cs#L5}
 */
export class BookingStageEnum extends Enum {
  static AwaitingOwnerApproval = 0
  static AwaitingPayment = 1
  static DeclinedByTheOwner = 2
  static DeclinedByTheRenter = 3
  static DepositTaken = 4
  static FullPaymentReceived = 6
  static SecurityDepositTaken = 7
  static PendingPayout = 11
  static Completed = 12
  static CanceledByTheRenter = 13
  static CanceledByTheOwner = 14
  static PendingInsuranceClaim = 15
  static ExpiredRequest = 16
  static ExpiredNoPayment = 17
  static EnquiryRequest = 18
  static ExpiredByAdmin = 19
  static TripStarted = 20
  static Invoice = 21
  static InstantBooking = 22
  static ExpiredInstantBook = 23
  static CompleteInProcess = 24
  static ProcessCompleteFail = 25
  static PendingPayoutOnCancel = 26
  static CanceledByTheAdmin = 27
}

/**
 * Make all the enums immutable
 */
Object.freeze(BookingStageEnum)
